import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    templateUrl: '500.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class P500Component {

  constructor() { }

}
